import {
    type interfaces,
    ContainerModule,
} from '@patsnap/tahiti-core/shared/inversify';

// Apis
import { AbCheckApiImpl } from './apis/impls/ab-check-api';
import { AbCheckApi } from './apis/ab-check-api';


export const abModule = new ContainerModule((bind: interfaces.Bind) => {
    // Bind APIs
    bind(AbCheckApi).to(AbCheckApiImpl);
});

// Export types and constants
export * from './types';
export * from './apis/ab-check-api';
